export enum MessageType {
  SUCCESS = 'success',
  NEUTRAL = 'neutral',
  ERROR = 'error',
}
